import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

function AboutPageTV() {
  const navigate = useNavigate()

  // Touche retour TV
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Backspace' || e.key === 'BrowserBack' || e.keyCode === 10009) {
        e.preventDefault()
        navigate('/')
      }
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [navigate])

  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      background: '#0a0a0a',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      color: '#fff'
    }}>

      {/* ── HEADER ── */}
      <div style={{
        flexShrink: 0,
        padding: 'clamp(10px, 1.6vh, 16px) clamp(14px, 2.2vw, 22px)',
        borderBottom: '1px solid rgba(255,215,0,0.15)',
        display: 'flex',
        alignItems: 'center',
        gap: 12
      }}>
        <h1 style={{
          fontSize: 'clamp(1.2rem, 2.5vw, 1.8rem)',
          fontWeight: 900,
          background: 'linear-gradient(135deg, #ffd700, #00d9ff)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          margin: 0
        }}>
          🎸 À Propos
        </h1>
      </div>

      {/* ── CONTENU SCROLLABLE ── */}
      <div style={{
        flex: 1,
        overflowY: 'auto',
        padding: 'clamp(12px, 1.8vh, 18px) clamp(14px, 2.2vw, 22px)',
        display: 'flex',
        flexDirection: 'column',
        gap: 'clamp(10px, 1.5vh, 14px)'
      }}>

        {/* BLOC PRINCIPAL */}
        <div style={{
          textAlign: 'center',
          padding: 'clamp(20px, 3.5vh, 35px) clamp(16px, 2.5vw, 30px)',
          background: 'linear-gradient(135deg, rgba(255,215,0,0.12), rgba(0,217,255,0.12))',
          borderRadius: 'clamp(14px, 2.2vh, 20px)',
          border: '2px solid rgba(255,215,0,0.35)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 'clamp(10px, 1.6vh, 16px)'
        }}>
          <div style={{ fontSize: 'clamp(2.5rem, 6vw, 4.5rem)' }}>🎸</div>
          <h2 style={{
            fontSize: 'clamp(1.4rem, 3.5vw, 2.6rem)',
            fontWeight: 900,
            background: 'linear-gradient(135deg, #00d9ff, #ffd700)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            margin: 0
          }}>
            Radio 100% Johnny
          </h2>
          <p style={{
            fontSize: 'clamp(0.85rem, 1.7vw, 1.1rem)',
            color: 'rgba(255,255,255,0.8)',
            lineHeight: 1.65,
            maxWidth: 680,
            margin: 0
          }}>
            La seule radio entièrement dédiée à Johnny Hallyday.<br />
            Écoutez le meilleur du rock français 24h/24, 7j/7.
          </p>
        </div>

        {/* GRILLE INFOS 3 colonnes */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: 'clamp(10px, 1.5vw, 14px)'
        }}>
          {[
            {
              emoji: '🎵',
              title: 'Notre Mission',
              text: 'Faire vivre l\'héritage musical de Johnny pour toutes les générations.',
              color: '#00d9ff',
              border: 'rgba(0,217,255,0.35)'
            },
            {
              emoji: '❤️',
              title: 'Nos Valeurs',
              text: 'Passion • Qualité • Communauté. Une radio créée par des fans, pour des fans.',
              color: '#ff1493',
              border: 'rgba(255,20,147,0.35)'
            },
            {
              emoji: '📧',
              title: 'Contact',
              text: 'contact@johnnysjh.fr\nNous sommes à votre écoute.',
              color: '#22c55e',
              border: 'rgba(34,197,94,0.35)'
            }
          ].map((card, i) => (
            <div key={i} style={{
              padding: 'clamp(14px, 2.2vh, 22px)',
              background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
              borderRadius: 'clamp(12px, 1.8vh, 16px)',
              border: `2px solid ${card.border}`,
              textAlign: 'center',
              display: 'flex', flexDirection: 'column',
              alignItems: 'center', gap: 'clamp(8px, 1.2vh, 12px)'
            }}>
              <div style={{ fontSize: 'clamp(1.8rem, 3.5vw, 2.6rem)' }}>{card.emoji}</div>
              <h3 style={{
                fontSize: 'clamp(0.88rem, 1.7vw, 1.05rem)',
                fontWeight: 900, color: card.color, margin: 0
              }}>
                {card.title}
              </h3>
              <p style={{
                fontSize: 'clamp(0.72rem, 1.4vw, 0.85rem)',
                lineHeight: 1.55,
                color: 'rgba(255,255,255,0.7)', margin: 0,
                whiteSpace: 'pre-line'
              }}>
                {card.text}
              </p>
            </div>
          ))}
        </div>

        {/* STATS RADIO */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: 'clamp(8px, 1.2vw, 12px)'
        }}>
          {[
            { emoji: '🎵', value: '24h/7j',   label: 'En direct'       },
            { emoji: '🎸', value: '100%',      label: 'Johnny Hallyday' },
            { emoji: '👥', value: '+4 000',    label: 'Auditeurs/jour'  },
            { emoji: '🏆', value: '50+ ans',   label: 'De musique'      }
          ].map((stat, i) => (
            <div key={i} style={{
              padding: 'clamp(12px, 1.8vh, 18px)',
              background: 'rgba(255,215,0,0.07)',
              border: '1px solid rgba(255,215,0,0.2)',
              borderRadius: 'clamp(10px, 1.5vh, 14px)',
              textAlign: 'center'
            }}>
              <div style={{ fontSize: 'clamp(1.4rem, 2.8vw, 2rem)', marginBottom: 4 }}>{stat.emoji}</div>
              <div style={{
                fontSize: 'clamp(1rem, 2vw, 1.4rem)',
                fontWeight: 900, color: '#ffd700'
              }}>
                {stat.value}
              </div>
              <div style={{
                fontSize: 'clamp(0.65rem, 1.3vw, 0.78rem)',
                color: 'rgba(255,255,255,0.55)', marginTop: 2
              }}>
                {stat.label}
              </div>
            </div>
          ))}
        </div>

        {/* VERSION */}
        <div style={{
          textAlign: 'center',
          padding: 'clamp(10px, 1.5vh, 14px)',
          background: 'rgba(20,20,20,0.7)',
          borderRadius: 'clamp(10px, 1.5vh, 14px)',
          border: '1px solid rgba(255,215,0,0.2)'
        }}>
          <p style={{ fontSize: 'clamp(0.72rem, 1.4vw, 0.85rem)', color: 'rgba(255,255,255,0.5)', margin: '0 0 4px' }}>
            Radio 100% Johnny — Version 1.0.0
          </p>
          <p style={{ fontSize: 'clamp(0.7rem, 1.3vw, 0.82rem)', color: 'rgba(255,255,255,0.65)', margin: 0 }}>
            Made with ❤️ by fans, for fans
          </p>
        </div>
      </div>

      {/* ── NAVIGATION TV ── */}
      <nav
        aria-label="Navigation TV"
        data-tv-bottom-nav="true"
        style={{
          flexShrink: 0,
          height: 40,
          display: 'grid',
          gridTemplateColumns: '1fr auto 1fr',
          alignItems: 'center',
          padding: '0 28px',
          background: 'rgba(12,7,16,.96)',
          borderTop: '1px solid rgba(255,215,0,.16)',
          color: '#999',
          fontSize: 'clamp(.72rem,1.05vw,.88rem)',
          boxSizing: 'border-box'
        }}
      >
        <button
          type="button"
          onClick={() => window.history.back()}
          aria-label="Navigation précédente"
          style={{
            justifySelf: 'start',
            border: 0,
            background: 'transparent',
            color: '#999',
            padding: '4px 0',
            fontSize: 'inherit',
            cursor: 'pointer',
            whiteSpace: 'nowrap'
          }}
        >
          ←→↑↓ Navigation  •  OK = Sélectionner
        </button>

        <div style={{
          color: '#ffd700',
          fontWeight: 800,
          letterSpacing: '.02em',
          whiteSpace: 'nowrap',
          textAlign: 'center'
        }}>
          100% JOHNNY
        </div>

        <button
          type="button"
          onClick={() => navigate('/')}
          aria-label="Retour accueil"
          style={{
            justifySelf: 'end',
            border: 0,
            background: 'transparent',
            color: '#999',
            padding: '4px 0',
            fontSize: 'inherit',
            cursor: 'pointer',
            whiteSpace: 'nowrap'
          }}
        >
          ↩ = Retour accueil
        </button>
      </nav>

      <style>{`
        button:focus { outline: none; }
        * { scrollbar-width: none; -ms-overflow-style: none; }
        *::-webkit-scrollbar { display: none; }
      `}</style>
    </div>
  )
}

export default AboutPageTV